export default __webpack_public_path__ + "static/media/faq-img.543169c7.png";